/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.14"
        height="19.01"
        viewBox="0 0 19.14 19.01"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M1.6 11.16 0 12.68l3.85 2.58 2.57 3.75 1.62-1.57-.26-3.2c.6-.43 1.39-1 2.38-1.83l2.44 6.24 2.23-2.44-.4-7.62a39 39 0 0 0 3.55-4 7 7 0 0 0 1.15-4l-.05-.53h-.54a7 7 0 0 0-4 1.14 39.32 39.32 0 0 0-4.09 3.54l-7.6-.4h-.06L.35 6.5l6.26 2.41c-.76.9-1.41 1.71-2 2.48Zm11.35 5.63-2-5c.35-.3 1-.82 1.6-1.41l.89-.82.34 6.33ZM2.19 6.15l.94-.85 6.38.34-.18.18-.33.36-.49.53-.74.82-.51.58Zm3.05 6.05c.65-.89 1.41-1.84 2.32-2.91l.25-.3c.06-.07.32-.39.68-.8s.5-.57.78-.87l1-1.06a38.9 38.9 0 0 1 4.84-4.32 5.79 5.79 0 0 1 3-.94 5.7 5.7 0 0 1-1 2.94 39.87 39.87 0 0 1-5 5.36 56.78 56.78 0 0 1-5.26 4.28l-.23.17.26 3.29-.43.42-1.94-2.85-3-2.08.37-.35 3.15.24Z"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'AirplaneIcon';

export default Icon;
